// Import everything from autoload
// import local dependencies
import Router from './util/Router';
import common from './routes/common'; // 共通

import home from './routes/home'; // ホーム

import pStudio from './routes/pStudio'; // MATY STUDIO

import reserve from './routes/reserve'; // MATY STUDIO -> 予約フォーム

import pGym from './routes/pGym'; // MATY GYM

import machine from './routes/machine'; // MATY GYM -> トレーニング機器一覧

import singleMachine from './routes/single-machine'; // MATY GYM -> トレーニング機器一覧 single

import news from './routes/news'; // NEWS、MATY STUDIO NEWS、MATY GYM NEWS

import topics from './routes/topics'; // TOPICS

import privacy from './routes/privacy'; // プライバシーポリシー

import contact from './routes/contact'; // お問い合わせ

/** import external dependencies */

import $ from 'jquery';

$.fn.animate2 = function (properties, duration, ease) {
  ease = ease || 'ease';
  var $this = this;
  var cssOrig = {
    transition: $this.css('transition')
  };
  return $this.queue(function (next) {
    properties['transition'] = 'all ' + duration + 'ms ' + ease;
    $this.css(properties);
    setTimeout(function () {
      $this.css(cssOrig);
      next();
    }, duration);
  });
};
/** Populate Router instance with DOM routes */


var routes = new Router({
  common: common,
  // 共通
  home: home,
  // ホーム
  pStudio: pStudio,
  // MATY STUDIO
  reserve: reserve,
  // MATY STUDIO -> 予約フォーム
  pGym: pGym,
  // MATY GYM
  machine: machine,
  // MATY GYM -> トレーニング機器一覧
  singleMachine: singleMachine,
  // MATY GYM -> トレーニング機器一覧
  news: news,
  // NEWS、MATY STUDIO NEWS、MATY GYM NEWS
  topics: topics,
  // TOPICS
  privacy: privacy,
  // プライバシーポリシー
  contact: contact // お問い合わせ

}); // Load Events

$(document).ready(function () {
  routes.loadEvents();
});